import type { Translations } from './error-messages.types'

/** German texts of backend messages (ADR-045). Missing keys show the English text. */
export const de: Translations = {
  'auth.access_token_expired': 'Das Zugriffstoken ist abgelaufen.',
  'auth.account_active': 'Das Konto ist nicht aktiv.',
  'auth.api_provided_plugin_which_enabled':
    'Diese API stammt vom Plugin „{pluginKey}“, das nicht aktiviert ist.',
  'auth.feature_turned_off': 'Die Funktion „{feature}“ ist ausgeschaltet.',
  'auth.invalid_access_token': 'Ungültiges Zugriffstoken.',
  'auth.invalid_token_type': 'Ungültiger Tokentyp.',
  'auth.plugin_active': 'Das Plugin ist nicht aktiv.',
  'auth.plugin_credentials_accepted_service':
    'Dieser Dienst akzeptiert keine Plugin-Zugangsdaten.',
  'auth.plugin_enabled': 'Das Plugin „{callerPluginKey}“ ist nicht aktiviert.',
  'auth.plugin_has_been_granted':
    'Dem Plugin „{callerPluginKey}“ wurde „{capability}“ nicht gewährt.',
  'auth.unknown_token_signing_key': 'Unbekannter Token-Signaturschlüssel.',
  'backup.coordinator_only':
    'Nur der Sicherungs-Koordinator darf diesen Endpunkt verwenden.',
  'backup.import_failed': 'Die Daten konnten nicht geladen werden: {reason}',
  'backup.import_running': 'Es läuft bereits ein Import.',
  'backup.link_expired': 'Der Download-Link ist ungültig oder abgelaufen.',
  'backup.not_importable':
    'Diese Sicherung kann hier nicht importiert werden. Laden Sie sie erneut hoch, um den Grund zu sehen.',
  'common.dependency_unavailable':
    'Ein benötigter Dienst ({dependency}) ist nicht erreichbar.',
  'common.forbidden': 'Sie haben keine Berechtigung für diese Aktion.',
  'common.not_found': 'Nicht gefunden ({resource}).',
  'common.not_found_id': 'Nicht gefunden ({resource} „{id}“).',
  'common.request_invalid': 'Die Anfrage ist ungültig.',
  'common.unauthenticated': 'Eine Anmeldung ist erforderlich.',
  'common.unexpected': 'Ein unerwarteter Fehler ist aufgetreten.',
  'contact.invalid_message': 'Please check the form.',
  'contact.invalid_settings': 'Invalid settings.',
  'contact.recaptcha_failed':
    'Die Spam-Prüfung ist fehlgeschlagen. Bitte versuchen Sie es erneut.',
  'contact.recaptcha_keys_missing':
    'Geben Sie beide reCAPTCHA-Schlüssel ein, um es einzuschalten.',
  'contact.recaptcha_unavailable':
    'Die Spam-Prüfung ist gerade nicht verfügbar. Bitte versuchen Sie es später erneut.',
  'contact.too_many_messages':
    'Too many messages. Please try again in a few minutes.',
  'content.active_content_type_needs_at':
    'Ein aktiver Inhaltstyp braucht mindestens ein Feld.',
  'issue.coin_change':
    'muss eine ganze Zahl sein, nicht 0, höchstens {max} in jede Richtung',
  'issue.reason_required': 'ist erforderlich, höchstens {max} Zeichen',
  'nearee.chat_open': 'Dieser Chat ist schon offen.',
  'nearee.chat_unlock_off':
    'Chats können gerade nicht mit Münzen geöffnet werden.',
  'nearee.invoice_no_buyer':
    'Die Käuferdaten sind nicht mehr vorhanden; stelle diese Rechnung bei Számlázz.hu aus.',
  'nearee.invoice_not_retryable':
    'Diese Rechnung kann nicht erneut versucht werden.',
  'nearee.push_invalid':
    'Wähle die Mitglieder und schreibe die Benachrichtigung (mindestens auf Englisch).',
  'nearee.meet_now_not_out':
    'Du kannst zum Sofort-Treffen einladen, solange ihr beide unterwegs und offen für ein Treffen seid.',
  'nearee.meet_now_expired': 'Diese Einladung ist abgelaufen.',
  'nearee.meet_now_renewed': 'Diese Einladung wurde schon erneuert.',
  'issue.meet_now_start_range': 'muss innerhalb von {hours} Stunden liegen',
  'nearee.push_nobody':
    'Keines der gewählten Mitglieder kann Benachrichtigungen erhalten.',
  'issue.push_recipients': 'wähle 1 bis {max} Mitglieder',
  'nearee.survey_locked':
    'Diese Umfrage gibt es mit NEAREE+, oder du öffnest sie mit Münzen.',
  'nearee.survey_open': 'Diese Umfrage ist schon offen.',
  'nearee.coins_already_spent': 'Das ist schon bezahlt.',
  'nearee.coins_change_invalid': 'Gib eine Anzahl Münzen und einen Grund an.',
  'nearee.coins_other_account':
    'Dieser Kauf gehört zu einem anderen NEAREE-Konto.',
  'nearee.coins_not_enough': 'Du hast nicht genug Münzen.',
  'nearee.coins_take_too_many': 'Das Mitglied hat nicht so viele Münzen.',
  'nearee.highlight_limit':
    'Du hast deine Hervorhebungen für diese Woche aufgebraucht.',
  'nearee.highlight_note_long': 'Die Notiz ist zu lang.',
  'nearee.email_search_forbidden':
    'Für die Suche nach E-Mail-Adresse ist die Berechtigung zur Nutzerverwaltung nötig.',
  'nearee.invalid_survey': 'Der Fragebogen ist ungültig.',
  'nearee.survey_key_taken':
    'Einen Fragebogen mit diesem Schlüssel gibt es schon.',
  'nearee.survey_changed':
    'Die Fragen haben sich inzwischen geändert. Bitte beginne den Fragebogen neu.',
  'nearee.survey_incomplete': 'Bitte beantworte alle Fragen.',
  'nearee.invalid_pack': 'Das Münzpaket ist ungültig.',
  'nearee.pack_key_taken': 'Ein Paket mit diesem Schlüssel gibt es schon.',
  'nearee.pack_product_taken':
    'Dieses Store-Produkt nutzt schon ein anderes Paket oder ein Tarif.',
  'nearee.store_unavailable': 'Käufe aus diesem Store sind nicht möglich.',
  'site.invalid_settings': 'Prüfen Sie die Website-Einstellungen.',
  'content.add_at_least_one_field':
    'Fügen Sie vor dem Aktivieren mindestens ein Feld hinzu.',
  'content.at_most_5_filters_allowed': 'Höchstens 5 Filter sind erlaubt.',
  'content.changing_field_compatible_existing_entries':
    'Ein Feld vom Typ {type} kann wegen bestehender Einträge nicht in {type2} geändert werden.',
  'content.content_type_already_exists':
    'Der Inhaltstyp „{inputKey}“ existiert bereits.',
  'content.entries_archived_content_types_published':
    'Einträge archivierter Inhaltstypen können nicht veröffentlicht werden.',
  'content.entries_created_active_content_types':
    'Einträge können nur für aktive Inhaltstypen erstellt werden.',
  'content.entry_data_invalid': 'Die Eintragsdaten sind ungültig.',
  'content.entry_has_no_draft_preview':
    'Der Eintrag hat keinen Entwurf für die Vorschau.',
  'content.entry_has_no_draft_version':
    'Der Eintrag hat keine Entwurfsversion.',
  'content.entry_languages_invalid': 'Die Sprachen des Eintrags sind ungültig.',
  'content.entry_published': 'Der Eintrag ist nicht veröffentlicht.',
  'content.entry_ready_publish':
    'Der Eintrag ist noch nicht bereit zur Veröffentlichung.',
  'content.entry_referenced':
    '{count} andere Einträge verweisen auf diesen Eintrag. Trotzdem löschen, um diese Verweise zu entfernen.',
  'content.entry_referenced_one':
    'Ein anderer Eintrag verweist auf diesen Eintrag. Trotzdem löschen, um den Verweis zu entfernen.',
  'content.entry_status':
    'Diese Aktion ist für einen Eintrag im Status {status} nicht möglich.',
  'content.entry_was_changed_someone_else':
    'Dieser Eintrag wurde von jemand anderem geändert. Laden Sie neu, um die aktuelle Version zu sehen.',
  'content.field_keys_renamed_while_entries':
    'Feldschlüssel können nicht umbenannt werden, solange Einträge existieren; fügen Sie stattdessen ein neues Feld hinzu.',
  'content.fieldids_must_list_every_field':
    'fieldIds muss jedes Feld des Inhaltstyps genau einmal enthalten.',
  'content.filter_must_map_field_keys':
    'filter muss Feldschlüsseln Textwerte zuordnen.',
  'content.filter_must_number': 'filter[{fieldKey}] muss eine Zahl sein.',
  'content.filtering_supported':
    'Filtern nach „{fieldKey}“ wird nicht unterstützt.',
  'content.invalid_content_type_key': 'Ungültiger Schlüssel des Inhaltstyps.',
  'content.invalid_content_type_settings':
    'Ungültige Einstellungen des Inhaltstyps.',
  'content.invalid_field_definition': 'Ungültige Felddefinition.',
  'content.invalid_schedule_time': 'Ungültiger Zeitpunkt.',
  'content.invalid_slug': 'Ungültiger Slug.',
  'content.localized_setting_change_while_entries':
    'Die Einstellung „übersetzt“ kann nicht geändert werden, solange Einträge existieren.',
  'content.multiple_setting_change_while_entries':
    'Die Einstellung „mehrere Werte“ kann nicht geändert werden, solange Einträge existieren.',
  'content.page_available':
    'Die Seite „{path}“ ist auf „{locale}“ nicht verfügbar.',
  'content.preview_link_invalid_has_expired':
    'Der Vorschau-Link ist ungültig oder abgelaufen.',
  'content.publishing_restored_version_requires_content':
    'Zum Veröffentlichen einer wiederhergestellten Version ist content.entry.publish erforderlich.',
  'content.reserved_key': '„{key}“ ist ein reservierter Schlüssel.',
  'content.scheduled_time_must_future':
    'Der geplante Zeitpunkt muss in der Zukunft liegen.',
  'content.slug_already_used_another_entry':
    'Der Slug „{slug}“ wird bereits von einem anderen Eintrag ({typeName}) verwendet.',
  'content.type_has_entries':
    'Dieser Inhaltstyp hat {count} Einträge. Löschen Sie mit „force“, um sie mitzulöschen, oder archivieren Sie den Typ.',
  'content.type_has_entry':
    'Dieser Inhaltstyp hat einen Eintrag. Löschen Sie mit „force“, um ihn mitzulöschen, oder archivieren Sie den Typ.',
  'content.unsupported_locale': 'Nicht unterstützte Sprache „{locale}“.',
  'content.url_already_used_another_published':
    'Die URL {nextPath} wird bereits von einem anderen veröffentlichten Eintrag verwendet.',
  'content.url_prefix_already_reserved':
    'Das URL-Präfix „{prefix}“ ist bereits für {owner} reserviert.',
  'content.url_prefix_already_used_content':
    'Das URL-Präfix „{prefix}“ wird bereits vom Inhaltstyp „{otherKey}“ verwendet.',
  'content.url_prefix_already_used_content_2':
    'Das URL-Präfix „{prefix}“ wird bereits vom Inhaltstyp „{key}“ verwendet.',
  'content.url_prefix_reserved': 'Das URL-Präfix „{prefix}“ ist reserviert.',
  'content.url_prefix_reserved_2':
    'Das URL-Präfix „{prefix}“ ist für {value} reserviert.',
  'content.you_delete_entries_you_created':
    'Sie können nur selbst erstellte Einträge löschen.',
  'crm.account_already_linked': 'Dieses Konto ist bereits verknüpft.',
  'crm.account_linked': 'Dieses Konto ist nicht verknüpft.',
  'crm.adjustments_need_reason': 'Korrekturen brauchen einen Grund.',
  'crm.another_price_already_valid_period':
    'In diesem Zeitraum gilt bereits ein anderer Preis. Bearbeiten oder löschen Sie ihn zuerst.',
  'crm.attachment_multipart':
    'Lade die Datei als multipart/form-data mit einem „file“-Teil hoch.',
  'crm.attachment_too_large': 'Dateien dürfen höchstens {max} MB groß sein.',
  'crm.available_sale': '{fName} ({sku}) ist nicht verkäuflich.',
  'crm.calendar_range_invalid':
    'Wählen Sie einen Zeitraum von höchstens {max} Tagen.',
  'crm.category_already_exists':
    'Die Kategorie „{inputKey}“ existiert bereits.',
  'crm.category_own_ancestor':
    'Eine Kategorie kann nicht ihr eigener Vorfahre sein.',
  'crm.choose_active_person': 'Wählen Sie eine aktive Person.',
  'crm.choose_customer_create_new_one':
    'Wählen Sie einen Kunden oder legen Sie einen neuen an.',
  'crm.choose_two_different_customers': 'Wählen Sie zwei verschiedene Kunden.',
  'crm.choose_two_different_warehouses': 'Wählen Sie zwei verschiedene Lager.',
  'crm.comment_invalid': 'The comment is invalid.',
  'crm.count_has_no_lines': 'Die Inventur hat keine Positionen.',
  'crm.count_no_longer_editable':
    'Diese Inventur kann nicht mehr bearbeitet werden.',
  'crm.count_was_already_posted_cancelled':
    'Diese Inventur wurde bereits gebucht oder storniert.',
  'crm.customer_anonymized_no_tickets': 'Dieser Kunde wurde anonymisiert.',
  'crm.customer_has_been_anonymized': 'Dieser Kunde wurde anonymisiert.',
  'crm.customer_was_merged_into_another':
    'Dieser Kunde wurde mit einem anderen Kunden zusammengeführt.',
  'crm.delete_detach_variants_first':
    'Löschen oder lösen Sie zuerst die Varianten.',
  'crm.document_invalid': 'The document is invalid.',
  'crm.document_multipart':
    'Upload the document as multipart/form-data with a "file" part.',
  'crm.enough_available': 'Nicht genug {context}: {value} verfügbar.',
  'crm.enough_stock': 'Nicht genug Bestand.',
  'crm.event_invalid': 'Der Termin ist ungültig.',
  'crm.idempotency_key_too_long': 'Der Idempotenzschlüssel ist zu lang.',
  'crm.import_columns_missing':
    'The file needs a first_name, last_name or company_name column.',
  'crm.import_file_invalid': 'The import file cannot be read.',
  'crm.import_file_missing': 'A "file" part is required.',
  'crm.import_malformed': 'Malformed upload: {message}',
  'crm.import_multipart':
    'Upload the file as multipart/form-data with a "file" part.',
  'crm.import_too_large': 'The import file may be at most {max} bytes.',
  'crm.invalid_amount': 'Ungültiger Betrag.',
  'crm.invalid_category_key': 'Ungültiger Kategorieschlüssel.',
  'crm.invalid_contact': 'Ungültiger Kontakt.',
  'crm.invalid_contacts': 'Ungültige Kontakte.',
  'crm.invalid_country': 'Ungültiges Land.',
  'crm.invalid_e_mail': 'Ungültige E-Mail.',
  'crm.invalid_expiry': 'Ungültiges Ablaufdatum.',
  'crm.invalid_quantity': 'Ungültige Menge.',
  'crm.invalid_reorder_level': 'Ungültiger Meldebestand.',
  'crm.invalid_reservation_lines': 'Ungültige Reservierungspositionen.',
  'crm.invalid_sku': 'Ungültige Artikelnummer.',
  'crm.invalid_validity_interval': 'Ungültiger Gültigkeitszeitraum.',
  'crm.invalid_warehouse_code': 'Ungültiger Lagercode.',
  'crm.name_required': 'Ein Name ist erforderlich.',
  'crm.no_active_warehouse': 'Create an active warehouse first.',
  'crm.note_empty': 'Eine Notiz darf nicht leer sein.',
  'crm.nothing_post': 'Nichts zu buchen.',
  'crm.offering_invalid': 'Diese Kombination ist nicht möglich.',
  'crm.only_own_comments': 'You can only delete your own comments.',
  'crm.price_list_already_exists':
    'Die Preisliste „{inputKey}“ existiert bereits.',
  'crm.product_has_stock_history_deleted':
    'Dieses Produkt hat eine Bestandshistorie und kann nicht gelöscht werden. Archivieren Sie es stattdessen.',
  'crm.product_own_variant':
    'Ein Produkt kann nicht seine eigene Variante sein.',
  'crm.reminder_invalid': 'The reminder is invalid.',
  'crm.reminder_not_scheduled': 'The reminder was already sent or cancelled.',
  'crm.reservation_not_changeable':
    'Die Reservierung ist {status} und kann nicht mehr geändert werden.',
  'crm.service_code_taken':
    'Eine Dienstleistung mit diesem Code existiert bereits.',
  'crm.service_integration_client_crm':
    'Der Dienst „{serviceName}“ ist kein Integrationspartner des CRM.',
  'crm.service_invalid': 'Die Dienstleistung ist ungültig.',
  'crm.sku_already_use': 'Die Artikelnummer „{sku}“ wird bereits verwendet.',
  'crm.stock_balance_was_locked': 'Der Lagerbestand wurde nicht gesperrt.',
  'crm.stock_quantity_invalid': 'The stock quantity is invalid.',
  'crm.stock_tracked_product': 'Für dieses Produkt wird kein Bestand geführt.',
  'crm.that_customer_already_linked_another':
    'Dieser Kunde ist bereits mit einem anderen Konto verknüpft.',
  'crm.ticket_attachments_invalid': 'Die Anhänge sind ungültig.',
  'crm.ticket_attachments_unknown':
    'Ein Anhang wurde nicht gefunden. Lade ihn erneut hoch.',
  'crm.ticket_closed':
    'Dieses Ticket ist geschlossen. Bitte eröffnen Sie ein neues.',
  'crm.ticket_invalid': 'Das Ticket ist ungültig.',
  'crm.ticket_message_invalid': 'Die Nachricht ist ungültig.',
  'crm.ticket_not_shared':
    'Teilen Sie das Ticket mit dem Kunden, bevor Sie antworten, oder fügen Sie eine interne Notiz hinzu.',
  'crm.ticket_too_many_open':
    'Sie haben {max} offene Tickets. Bitte warten Sie auf eine Antwort, bevor Sie ein weiteres eröffnen.',
  'crm.ticket_verify_email':
    'Bitte bestätigen Sie Ihre E-Mail-Adresse, bevor Sie ein Ticket eröffnen.',
  'crm.unknown_product': 'Unbekanntes Produkt.',
  'crm.unknown_warehouse': 'Unbekanntes Lager.',
  'crm.unsupported_currency': 'Nicht unterstützte Währung.',
  'crm.use_reservation_transfer_commands_movement':
    'Verwenden Sie für diese Bewegung die Reservierungs- oder Umlagerungsbefehle.',
  'crm.variants_have_variants': 'Varianten können keine Varianten haben.',
  'crm.warehouse_already_exists': 'Das Lager „{code}“ existiert bereits.',
  'crm.warehouse_has_stock_history_deactivate':
    'Dieses Lager hat eine Bestandshistorie. Deaktivieren Sie es stattdessen.',
  'crm.warehouse_inactive': 'Das Lager {wCode} ist inaktiv.',
  'crm.you_delete_your_own_notes': 'Sie können nur eigene Notizen löschen.',
  'crm.zip_selection_invalid': 'Select 1 to {max} documents.',
  'crm.zip_too_large': 'The selected documents are too large for one download.',
  'http.400': 'Die Anfrage ist ungültig.',
  'http.401': 'Eine Anmeldung ist erforderlich.',
  'http.403': 'Sie haben keine Berechtigung für diese Aktion.',
  'http.404': 'Nicht gefunden.',
  'http.405': 'Diese Methode ist nicht erlaubt.',
  'http.409': 'Die Anfrage steht im Konflikt mit dem aktuellen Zustand.',
  'http.413': 'Die Anfrage ist zu groß.',
  'http.415': 'Dieser Medientyp wird nicht unterstützt.',
  'http.429': 'Zu viele Anfragen. Bitte versuchen Sie es später erneut.',
  'identity.administrator_permissions_changed':
    'Die Berechtigungen der Administratorrolle können nicht geändert werden.',
  'identity.at_least_one_active_administrator':
    'Mindestens ein aktiver Administrator muss bleiben.',
  'identity.confirm_account_deletion':
    'Bestätige, dass das Konto gelöscht werden soll.',
  'identity.csrf_token_missing_invalid': 'CSRF-Token fehlt oder ist ungültig.',
  'identity.current_password_incorrect': 'Das aktuelle Passwort ist falsch.',
  'identity.displayname_must_1_120_characters':
    'Der Anzeigename muss 1–120 Zeichen lang sein.',
  'identity.invalid_client_credentials': 'Ungültige Client-Zugangsdaten.',
  'identity.invalid_credentials': 'E-Mail-Adresse oder Passwort ist falsch.',
  'identity.invalid_email_address': 'Ungültige E-Mail-Adresse.',
  'identity.invalid_plugin_key': 'Ungültiger Plugin-Schlüssel.',
  'identity.invalid_plugin_permissions': 'Ungültige Plugin-Berechtigungen.',
  'identity.invalid_role_key': 'Ungültiger Rollenschlüssel.',
  'identity.link_invalid_expired': 'Dieser Link ist ungültig oder abgelaufen.',
  'identity.mfa_already_enabled':
    'Die Zwei-Faktor-Authentifizierung ist bereits aktiviert.',
  'identity.mfa_blocked':
    'Zu viele falsche Codes. Versuchen Sie es in ein paar Minuten erneut.',
  'identity.mfa_challenge_expired':
    'Die Anmeldung ist abgelaufen. Bitte melden Sie sich erneut an.',
  'identity.mfa_invalid_code': 'Der Code ist ungültig.',
  'identity.mfa_not_enabled':
    'Die Zwei-Faktor-Authentifizierung ist deaktiviert.',
  'identity.mfa_secret_unreadable':
    'Die Zwei-Faktor-Authentifizierung kann nicht geprüft werden; bitten Sie einen Administrator, sie zurückzusetzen.',
  'identity.mfa_setup_first': 'Starten Sie zuerst die Einrichtung.',
  'identity.mfa_unavailable':
    'Die Zwei-Faktor-Authentifizierung ist in dieser Installation nicht verfügbar.',
  'identity.no_active_session': 'Keine aktive Sitzung.',
  'identity.notification_invalid': 'The notification is invalid.',
  'identity.one_more_roles_do_exist':
    'Eine oder mehrere Rollen existieren nicht.',
  'identity.password_does_meet_password_policy':
    'Das Passwort erfüllt die Passwortrichtlinie nicht.',
  'identity.please_confirm_your_e_mail':
    'Bitte bestätigen Sie zuerst Ihre E-Mail-Adresse. Wir haben Ihnen einen Link gesendet.',
  'identity.role_already_exists': 'Die Rolle „{inputKey}“ existiert bereits.',
  'identity.service_may_request_plugin_credentials':
    'Dieser Dienst darf keine Plugin-Zugangsdaten anfordern.',
  'identity.session_expired_please_sign_again':
    'Die Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.',
  'identity.sign_in_code_invalid':
    'Der Code ist falsch oder abgelaufen. Fordere einen neuen an.',
  'identity.sign_in_provider_unavailable':
    'Diese Anmeldemethode ist nicht verfügbar.',
  'identity.sign_in_token_invalid':
    'Die Anmeldung konnte nicht überprüft werden. Bitte versuche es erneut.',
  'identity.status_set_manually':
    'Der Status kann nicht manuell auf {to} gesetzt werden.',
  'identity.system_roles_deleted': 'Systemrollen können nicht gelöscht werden.',
  'identity.unknown_permissions': 'Unbekannte Berechtigungen.',
  'identity.unknown_token_signing_key': 'Unbekannter Token-Signaturschlüssel.',
  'identity.user_email_already_exists':
    'Es gibt bereits einen Benutzer mit dieser E-Mail-Adresse.',
  'identity.you_delete_your_own_account':
    'Sie können Ihr eigenes Konto nicht löschen.',
  'identity.you_disable_your_own_account':
    'Sie können Ihr eigenes Konto nicht deaktivieren.',
  'issue.add_at_least_one_line': 'mindestens eine Position hinzufügen',
  'issue.already_used': 'wird bereits verwendet',
  'issue.ambiguous_match': 'several customers have this e-mail address',
  'issue.at_most_200_characters': 'höchstens 200 Zeichen',
  'issue.at_most_items': 'darf höchstens {max} Einträge haben',
  'issue.available': 'nur {total} verfügbar',
  'issue.belongs_gx_cms_core': '„{prefix}“ gehört zum GX-CMS-Kern',
  'issue.belongs_plugin': '„{dKey}“ gehört zum Plugin „{owner}“',
  'issue.cannot_change': 'kann nicht geändert werden',
  'issue.cannot_report_yourself': 'du kannst dich nicht selbst melden',
  'issue.choose_at_least_one_language': 'mindestens eine Sprache wählen',
  'issue.contains_unknown_role_ids': 'enthält unbekannte Rollen-IDs',
  'issue.content_language': 'ist keine Inhaltssprache',
  'issue.content_language_use':
    '„{l}“ ist keine Inhaltssprache (möglich: {supported})',
  'issue.core_permission': '„{dKey}“ ist eine Kernberechtigung',
  'issue.count_at_least_one_product': 'mindestens ein Produkt zählen',
  'issue.date_start_range':
    'muss zwischen {minutes} Minuten und {days} Tagen in der Zukunft liegen',
  'issue.does_exist': 'existiert nicht',
  'issue.does_track_stock': 'für {sku} wird kein Bestand geführt',
  'issue.duplicate_field_key': 'doppelter Feldschlüssel „{fKey}“',
  'issue.duplicate_in_file': 'also in row {line}',
  'issue.e_mail_address': 'ist keine E-Mail-Adresse',
  'issue.eligible_customer': 'kein geeigneter Kunde',
  'issue.email_not_verified': 'E-Mail-Adresse noch nicht bestätigt',
  'issue.end_after_start': 'muss nach dem Beginn liegen',
  'issue.entries_type_allowed_here':
    'Einträge vom Typ „{contentTypeKey}“ sind hier nicht erlaubt',
  'issue.entry_reference_itself':
    'ein Eintrag kann nicht auf sich selbst verweisen',
  'issue.enum_fields_need_at_least':
    'Auswahlfelder brauchen mindestens eine Option',
  'issue.error': '{fName} ({sku}): {message}',
  'issue.event_too_long': 'ein Termin darf höchstens {max} Tage dauern',
  'issue.exactly_one_customerid_createcustomer':
    'genau eines von customerId / createCustomer',
  'issue.field_content_type': 'ist kein Feld dieses Inhaltstyps',
  'issue.fields_hold_multiple_values':
    'Felder vom Typ {type} können keine mehreren Werte haben',
  'issue.file_does_exist_inside_package':
    'Datei „{rel}“ fehlt im Paket (wurde das Plugin gebaut?)',
  'issue.file_empty': 'The file is empty.',
  'issue.file_too_large': 'The file is too large.',
  'issue.file_unreadable': 'The file is not a valid Excel workbook.',
  'issue.filterable': 'nicht filterbar',
  'issue.has_no_matching_events_subscribe':
    '„{cap}“ hat keine passende events.subscribe-Deklaration',
  'issue.http_url': 'muss eine http(s)-URL sein',
  'issue.import_name_column': 'no name column',
  'issue.incorrect': 'ist falsch',
  'issue.invalid': 'ist ungültig',
  'issue.invalid_attendees': 'höchstens {max} Mitarbeitende angeben',
  'issue.inventory_needs_products': 'Lagerführung erfordert Produkte',
  'issue.iso_date': 'must be a date',
  'issue.job_ids_must_unique': 'Job-IDs müssen eindeutig sein',
  'issue.length_between': '1 to {min} characters',
  'issue.max_characters': 'must be at most {max} characters',
  'issue.max_files': 'darf höchstens {max} Dateien enthalten',
  'issue.max_items': 'at most {max} tags',
  'issue.max_recipients': 'must have at most {max} recipients',
  'issue.media_asset_does_exist': 'Medium {assetId} existiert nicht',
  'issue.media_asset_ready':
    'Medium {assetId} ist nicht bereit ({assetStatus})',
  'issue.media_type_allowed': 'Medientyp {mimeType} ist nicht erlaubt',
  'issue.migration_ids_must_unique': 'Migrations-IDs müssen eindeutig sein',
  'issue.minitems_maxitems_require_multiple_true':
    'minItems/maxItems erfordern multiple=true',
  'issue.must_accepted': 'muss akzeptiert werden',
  'issue.must_after_validfrom': 'muss nach validFrom liegen',
  'issue.must_at_least_characters':
    'muss mindestens {minLength} Zeichen lang sein',
  'issue.must_at_most_256_characters': 'darf höchstens 256 Zeichen lang sein',
  'issue.must_be_one_of': 'muss eines davon sein: {options}',
  'issue.must_between': 'must be between {min} and {max}',
  'issue.must_boolean': 'muss ein Wahrheitswert sein',
  'issue.must_contain_at_least_three':
    'muss mindestens drei davon enthalten: Kleinbuchstaben, Großbuchstaben, Ziffer, Sonderzeichen',
  'issue.must_contain_duplicates': 'darf keine Duplikate enthalten',
  'issue.must_current_version': 'muss die aktuelle Version sein',
  'issue.must_differ_from_source': 'muss sich von der Quelle unterscheiden',
  'issue.must_differ_from_target': 'muss sich vom Ziel unterscheiden',
  'issue.must_endpoint_signing_secret_whsec':
    'muss das Signatur-Geheimnis des Endpunkts sein (whsec_…)',
  'issue.must_future': 'muss in der Zukunft liegen',
  'issue.must_future_within_minutes':
    'muss in der Zukunft und innerhalb von {RESERVATIONMAXMINUTES} Minuten liegen',
  'issue.must_have_form_pluginkey_widgetid':
    'muss die Form <pluginKey>/<widgetId> haben',
  'issue.must_host_name': 'must be a host name',
  'issue.must_http_s_url_template': 'muss eine http(s)-URL-Vorlage sein',
  'issue.must_integer': 'muss eine ganze Zahl von {min} bis {max} sein',
  'issue.must_iso_date_time': 'muss ein ISO-Datum mit Uhrzeit sein',
  'issue.must_list_non_empty_strings':
    'muss eine Liste nicht leerer Texte sein',
  'issue.must_max': 'muss <= max sein',
  'issue.must_maxitems': 'muss <= maxItems sein',
  'issue.must_maxlength': 'muss <= maxLength sein',
  'issue.must_newer_than_plugin_version':
    'darf nicht neuer als die Plugin-Version sein',
  'issue.must_non_negative_integer': 'muss eine nicht negative ganze Zahl sein',
  'issue.must_non_negative_integer_minor':
    'muss eine nicht negative ganze Zahl in Cent sein',
  'issue.must_non_zero_integer': 'muss eine ganze Zahl ungleich null sein',
  'issue.must_none_tls': 'must be none or tls',
  'issue.must_not_empty': 'darf nicht leer sein',
  'issue.must_not_greater_than': 'darf nicht größer sein als {other}',
  'issue.must_number': 'muss eine Zahl sein',
  'issue.must_number_between': 'muss eine Zahl von {min} bis {max} sein',
  'issue.must_object': 'muss ein Objekt sein',
  'issue.must_one': 'muss einer von {FIELDTYPES} sein',
  'issue.must_positive_integer': 'muss eine positive ganze Zahl sein',
  'issue.must_reference_another_product':
    'muss auf ein anderes Produkt verweisen',
  'issue.must_reference_base_product': 'muss auf ein Basisprodukt verweisen',
  'issue.must_reference_single_value_text':
    'muss auf ein einwertiges Textfeld verweisen',
  'issue.must_single_non_localized_enum':
    'muss ein einzelnes, nicht übersetztes Auswahl- oder Verknüpfungsfeld sein',
  'issue.must_start': 'muss mit „{ns}“ beginnen',
  'issue.must_start_letter_contain_letters':
    'muss mit einem Buchstaben beginnen und darf nur Buchstaben, Ziffern und _ enthalten',
  'issue.must_stripe_secret_restricted_key':
    'muss ein geheimer oder eingeschränkter Stripe-Schlüssel sein (sk_…/rk_…)',
  'issue.must_text_at_most_120': 'muss ein Text mit höchstens 120 Zeichen sein',
  'issue.must_valid_email_address': 'muss eine gültige E-Mail-Adresse sein',
  'issue.must_valid_regular_expression':
    'muss ein gültiger regulärer Ausdruck sein',
  'issue.must_valid_semver_range': 'muss ein gültiger Semver-Bereich sein',
  'issue.non_negative_amount': 'muss ein nicht negativer Betrag sein',
  'issue.not_allowed': 'ist nicht erlaubt',
  'issue.not_in_past': 'must not be in the past',
  'issue.notification_link': 'must be an admin path starting with /',
  'issue.notification_permissions': 'must be permission keys',
  'issue.notification_recipients': 'name at least one user or permission',
  'issue.notification_source': 'use lower-case letters, digits and . _ : -',
  'issue.notification_text': 'use a text or { "<language>": text }',
  'issue.notification_too_many_users': 'at most {max} users',
  'issue.notification_type': 'use lower-case letters, digits and . _ -',
  'issue.notification_user_ids': 'must be user ids',
  'issue.one_weight_above_zero': 'mindestens ein Gewicht muss über null liegen',
  'issue.page_widget_field_widget_ids':
    'Seiten-, Widget- und Feld-Widget-IDs müssen eindeutig sein',
  'issue.permission_keys_must_unique':
    'Berechtigungsschlüssel müssen eindeutig sein',
  'issue.plugin_depend_itself':
    'ein Plugin kann nicht von sich selbst abhängen',
  'issue.positive_minutes': 'muss eine positive Anzahl Minuten sein',
  'issue.posted_directly': '„{type}“ kann nicht direkt gebucht werden',
  'issue.product_does_exist': 'Produkt {id} existiert nicht',
  'issue.provide_display_name_person_name':
    'geben Sie einen Anzeigenamen, einen Personennamen oder einen Firmennamen an',
  'issue.range_too_long': 'liegt außerhalb des zulässigen Bereichs',
  'issue.referenced_entry_archived':
    'der verknüpfte Eintrag {targetEntryId} ist archiviert',
  'issue.referenced_entry_does_exist':
    'der verknüpfte Eintrag {targetEntryId} existiert nicht',
  'issue.references_undeclared_feature':
    "references undeclared feature '{feature}'",
  'issue.references_undeclared_page':
    'verweist auf die nicht deklarierte Seite „{page}“',
  'issue.references_undeclared_permission':
    "verweist auf eine nicht deklarierte Berechtigung '{permission}'",
  'issue.reminder_range': 'muss zwischen 0 Minuten und 14 Tagen liegen',
  'issue.requested_plugin': '„{c}“ wird vom Plugin nicht angefordert',
  'issue.required': 'ist erforderlich',
  'issue.required_content_type': 'ist für diesen Inhaltstyp erforderlich',
  'issue.required_event_subscriptions_jobs':
    'ist für Event-Abonnements und Jobs erforderlich',
  'issue.required_verify_webhooks': 'ist zum Prüfen von Webhooks erforderlich',
  'issue.required_when_admin_ui_extensions':
    'ist erforderlich, wenn Admin-Erweiterungen deklariert sind',
  'issue.required_when_permissions_features_declared':
    'ist erforderlich, wenn Berechtigungen oder Funktionen deklariert sind',
  'issue.requires_capability': '{why} erfordert die Berechtigung „{cap}“',
  'issue.reserved': 'ist reserviert',
  'issue.reserved_2': '„{fieldKey}“ ist reserviert',
  'issue.reserved_3': '„{prefix}“ ist reserviert',
  'issue.row_failed': 'could not be imported',
  'issue.select_documents': 'select 1 to {max} documents',
  'issue.sender_name': 'must be at most 120 characters without < > or quotes',
  'issue.simplepay_supports_huf_eur_usd':
    'SimplePay unterstützt HUF, EUR und USD',
  'issue.supported': '„{currency}“ wird nicht unterstützt',
  'issue.supported_fields': 'wird für Felder vom Typ {type} nicht unterstützt',
  'issue.supported_locale': 'ist keine unterstützte Sprache',
  'issue.supported_routing_setting':
    'ist keine unterstützte Routing-Einstellung',
  'issue.supported_setting': 'ist keine unterstützte Einstellung',
  'issue.tag_max_characters': 'tags must be at most {max} characters',
  'issue.tax_rate_range': 'muss zwischen 0 und 100 % liegen',
  'issue.test_provider_used_production':
    'der Testanbieter kann im Produktivbetrieb nicht verwendet werden',
  'issue.too_long': 'ist zu lang',
  'issue.too_many_columns': 'The file has too many columns (at most {max}).',
  'issue.too_many_rows': 'The file has too many rows (at most {max}).',
  'issue.unavailable': 'nicht verfügbar',
  'issue.unknown_capability': 'unbekannte Berechtigung „{cap}“',
  'issue.unknown_field': 'unbekanntes Feld',
  'issue.unknown_permission': 'unbekannte Berechtigung „{p}“',
  'issue.unsupported_currency': 'wird nicht unterstützt',
  'issue.use_1_32_letters_digits':
    '1–32 Buchstaben, Ziffern, Bindestriche oder Unterstriche verwenden',
  'issue.use_1_64_letters_digits':
    '1–64 Buchstaben, Ziffern, Punkte, Bindestriche oder Unterstriche verwenden',
  'issue.use_2_63_lowercase_letters':
    '2–63 Kleinbuchstaben, Ziffern oder _ verwenden, beginnend mit einem Buchstaben',
  'issue.use_iso_3166_1_alpha': 'einen ISO-3166-1-alpha-2-Code verwenden',
  'issue.use_lower_case_letters_digits':
    'Kleinbuchstaben, Ziffern und Bindestriche verwenden',
  'issue.use_lowercase_letters_digits':
    'Kleinbuchstaben, Ziffern, - und _ verwenden',
  'issue.use_lowercase_letters_digits_single':
    'Kleinbuchstaben, Ziffern und einzelne Bindestriche verwenden',
  'issue.use_one': 'möglich: {supported}',
  'issue.use_one_2': 'möglich: {CONTENTLOCALES}',
  'issue.use_one_3': 'möglich: {value}',
  'issue.valid_e_mail_address': 'ist keine gültige E-Mail-Adresse',
  'issue.valid_json_schema': 'ist kein gültiges JSON-Schema: {message}',
  'issue.valid_phone_number': 'ist keine gültige Telefonnummer',
  'issue.webshop_needs_inventory':
    'der Webshop reserviert Lagerbestand; deaktivieren Sie zuerst den Webshop',
  'issue.webshop_needs_products':
    'der Webshop verkauft Produkte; deaktivieren Sie zuerst den Webshop',
  'issue.website_language': 'muss eine der Sprachen der Website sein',
  'issue.whole_number_min_0': 'must be a whole number ≥ 0',
  'issue.would_create_cycle': 'würde einen Zyklus erzeugen',
  'issue.xls_unsupported':
    'Old Excel files (.xls) are not supported. Save the file as .xlsx or CSV.',
  'mail.invalid_plugin_key': "'{pluginKey}' is not a plugin key.",
  'mail.invalid_request': 'Invalid e-mail.',
  'mail.invalid_smtp_settings': 'Invalid e-mail settings.',
  'mail.password_unreadable':
    'The stored SMTP password cannot be read; enter it again.',
  'mail.secrets_key_missing':
    'Set MAIL_SECRETS_KEY on the identity service to store SMTP passwords.',
  'mail.send_plugins_services_only':
    'Only plugins and services send e-mail through this API.',
  'mail.service_not_mail_client':
    "Service '{service}' may not send e-mail (MAIL_CLIENTS).",
  'media.deleted_assets_changed':
    'Gelöschte Medien können nicht geändert werden.',
  'media.file_empty': 'Die Datei ist leer.',
  'media.file_part_required': 'Ein Teil „file“ ist erforderlich.',
  'media.file_type_allowed_allowed_types':
    'Dieser Dateityp ist nicht erlaubt. Erlaubte Typen: {allowed}.',
  'media.file_used':
    'Diese Datei wird in {count} Einträgen verwendet. Wenn Sie sie trotzdem löschen, lädt sie dort nicht mehr, und die Einträge brauchen vor der nächsten Veröffentlichung eine neue Datei.',
  'media.file_used_once':
    'Diese Datei wird in einem Eintrag verwendet. Wenn Sie sie trotzdem löschen, lädt sie dort nicht mehr, und der Eintrag braucht vor der nächsten Veröffentlichung eine neue Datei.',
  'media.files_may_at_most_bytes':
    'Dateien dürfen höchstens {maxBytes} Byte groß sein.',
  'media.files_may_at_most_bytes_2':
    'Dateien dürfen höchstens {MEDIAMAXBYTES} Byte groß sein.',
  'media.malformed_upload': 'Fehlerhafter Upload: {message}',
  'media.owner_scope_invalid': 'A valid owner scope is required.',
  'media.text_file_invalid': 'The text file is not valid UTF-8 text.',
  'media.use_multipart_form_data_file':
    'Verwenden Sie multipart/form-data mit einem Teil „file“.',
  'media.you_delete_media_you_uploaded':
    'Sie können nur selbst hochgeladene Medien löschen.',
  'nearee.access_reason_required':
    'Gib einen Grund an, warum du die Unterhaltung öffnest.',
  'nearee.account_blocked': 'Dieses Konto kann nicht genutzt werden.',
  'nearee.account_not_active': 'Nur ein aktives Konto kann pausiert werden.',
  'nearee.account_not_paused': 'Das Konto ist nicht pausiert.',
  'nearee.already_premium': 'Du hast bereits NEAREE+.',
  'nearee.birth_date_set':
    'Das Geburtsdatum ist bereits gesetzt. Wende dich zur Korrektur an den Support.',
  'nearee.cancel_in_store':
    'Store-Abos werden im App Store oder bei Google Play gekündigt.',
  'nearee.cannot_block_yourself': 'Du kannst dich nicht selbst blockieren.',
  'nearee.chat_closed': 'Diese Unterhaltung ist beendet.',
  'nearee.chat_empty_message': 'Schreib zuerst etwas.',
  'nearee.chat_invalid_client_id': 'Ungültige Nachrichten-ID.',
  'nearee.chat_message_too_long': 'Die Nachricht ist zu lang.',
  'nearee.chat_rate_limited': 'Du sendest zu schnell. Warte einen Moment.',
  'nearee.configuration_changed_meanwhile':
    'Jemand anderes hat die Konfiguration geändert. Lade sie neu und versuche es erneut.',
  'nearee.configuration_version_outdated':
    'Diese Version erfüllt die aktuellen Regeln nicht mehr und kann nicht wiederhergestellt werden.',
  'nearee.consents_required':
    'Akzeptiere die aktuellen Bedingungen und die Verarbeitung sensibler Daten, um fortzufahren.',
  'nearee.conversation_not_reported':
    'Diese Unterhaltung ist nicht Gegenstand der Meldung.',
  'nearee.date_already_open': 'Mit diesem Match ist schon ein Date in Planung.',
  'nearee.date_changed':
    'Der Plan hat sich inzwischen geändert. Sieh dir den neuen an.',
  'nearee.date_confirm_other':
    'Dein Match bestätigt den Plan, den du gemacht hast.',
  'nearee.date_feedback_given': 'Du hast schon geantwortet.',
  'nearee.date_feedback_not_open': 'Du kannst nach dem Date antworten.',
  'nearee.date_in_past': 'Diese Zeit ist vorbei. Schlag eine neue vor.',
  'nearee.date_not_open': 'Dieses Date kann nicht mehr geändert werden.',
  'nearee.date_not_planning':
    'Planen geht, nachdem die Einladung angenommen wurde und bevor das Date bestätigt ist.',
  'nearee.date_nothing_to_confirm': 'Es gibt noch keinen Plan zum Bestätigen.',
  'nearee.experiment_exists':
    'Ein Experiment mit diesem Schlüssel gibt es schon.',
  'nearee.experiment_status':
    'Das Experiment kann jetzt nicht zu {status} wechseln.',
  'nearee.finish_onboarding_first':
    'Bestätige zuerst dein Alter und akzeptiere die Bedingungen.',
  'nearee.invalid_birth_date': 'Ungültiges Geburtsdatum.',
  'nearee.invalid_configuration': 'Ungültige Konfiguration.',
  'nearee.invalid_date_plan': 'Ungültiger Date-Plan.',
  'nearee.invalid_decision': 'Ungültige Entscheidung.',
  'nearee.invalid_experiment': 'Ungültiges Experiment.',
  'nearee.invalid_location': 'Ungültiger Standort.',
  'nearee.invalid_period': 'Ungültiger Zeitraum.',
  'nearee.invalid_profile': 'Ungültiges Profil.',
  'nearee.invalid_push_token': 'Ungültiges Push-Token.',
  'nearee.invalid_report': 'Ungültige Meldung.',
  'nearee.invalid_restriction': 'Ungültige Einschränkung.',
  'nearee.invalid_time_zone': 'Unbekannte Zeitzone.',
  'nearee.invalid_verification': 'Ungültige Verifizierungsanfrage.',
  'nearee.invalid_verification_decision':
    'Ungültige Verifizierungsentscheidung.',
  'nearee.like_limit':
    'Deine Likes für heute sind aufgebraucht. Morgen wieder.',
  'nearee.location_needed':
    'Teile zuerst deinen Standort (während du die App nutzt).',
  'nearee.photo_limit': 'Ein Profil kann höchstens {max} Fotos haben.',
  'nearee.photo_missing': 'Es wurde kein Foto gesendet.',
  'nearee.photo_multipart':
    'Sende das Foto als multipart/form-data mit einem „file“-Teil.',
  'nearee.photo_order_invalid':
    'Die Reihenfolge muss jedes Foto genau einmal enthalten.',
  'nearee.photo_too_large': 'Das Foto ist zu groß.',
  'nearee.photo_too_small':
    'Das Foto ist zu klein. Es muss mindestens {min} Pixel breit und hoch sein.',
  'nearee.photo_unsupported': 'Verwende ein JPEG-, PNG- oder WebP-Foto.',
  'nearee.plan_in_use':
    'Dieser Tarif hat Abos; blende ihn aus, statt ihn zu löschen.',
  'nearee.plan_invalid': 'Der Tarif ist ungültig.',
  'nearee.plan_key_fixed':
    'Der Schlüssel eines Tarifs kann nicht geändert werden.',
  'nearee.plan_key_taken': 'Es gibt bereits einen Tarif mit diesem Schlüssel.',
  'nearee.plan_product_taken':
    'Ein anderer Tarif nutzt dieses Store-Produkt bereits.',
  'nearee.plus_required_chat':
    'Chatten ist Teil von NEAREE+. Der Chat öffnet sich, wenn du oder dein Match NEAREE+ hat.',
  'nearee.plus_required_date':
    'Eine Date-Einladung zu senden ist Teil von NEAREE+.',
  'nearee.premium_required': 'Das ist Teil von NEAREE+.',
  'nearee.premium_unavailable': 'NEAREE+ ist gerade nicht verfügbar.',
  'nearee.reaction_unknown': 'Wähle eine der Reaktionen.',
  'nearee.profile_not_ready':
    'Vervollständige dein Profil (und setze ein pausiertes Konto fort), um Menschen zu sehen.',
  'nearee.purchase_other_account':
    'Dieses Abo gehört zu einem anderen NEAREE-Konto.',
  'nearee.purchase_rejected': 'Der Store hat diesen Kauf nicht bestätigt.',
  'nearee.report_closed': 'Über diese Meldung wurde bereits entschieden.',
  'nearee.report_taken': 'Eine andere Person moderiert diese Meldung bereits.',
  'nearee.restriction_already_lifted':
    'Diese Einschränkung wurde bereits aufgehoben.',
  'nearee.return_url_invalid': 'Diese Rücksprungadresse ist nicht erlaubt.',
  'nearee.too_many_reports':
    'Du hast heute zu viele Meldungen gesendet. Bitte versuche es morgen erneut.',
  'nearee.rewind_none': 'Es gibt nichts, wozu du zurückkehren kannst.',
  'nearee.unmatch_instead': 'Ihr seid ein Match: löse es stattdessen auf.',
  'nearee.verification_decided':
    'Über diese Verifizierung wurde bereits entschieden.',
  'nearee.verification_pending':
    'Eine Verifizierung dieser Art wartet bereits auf Prüfung.',
  'nearee.web_checkout_unavailable':
    'Webzahlungen sind gerade nicht verfügbar.',
  'plugin.capabilities_requested_manifest_granted':
    'Nur im Manifest angeforderte Berechtigungen können gewährt werden.',
  'plugin.complete_plugin_configuration_before_enabling':
    'Vervollständigen Sie die Plugin-Konfiguration vor dem Aktivieren.',
  'plugin.disable_dependent_plugins_first':
    'Deaktivieren Sie zuerst abhängige Plugins: {value}.',
  'plugin.disable_plugin_before_uninstalling':
    'Deaktivieren Sie das Plugin vor dem Deinstallieren.',
  'plugin.enable_dependencies_first':
    'Aktivieren Sie zuerst die Abhängigkeiten: {value}.',
  'plugin.gx_cms_instance_installs_signed':
    'Diese GX-CMS-Instanz installiert nur signierte Plugin-Pakete.',
  'plugin.incompatible': 'Das Plugin ist nicht kompatibel: {problems}',
  'plugin.install_plugin_before_changing_features':
    'Installieren Sie das Plugin, bevor Sie seine Funktionen ändern.',
  'plugin.install_plugin_before_granting_capabilities':
    'Installieren Sie das Plugin, bevor Sie Berechtigungen gewähren.',
  'plugin.invalid_collection_record_key':
    'Ungültiger Sammlungs- oder Datensatzschlüssel.',
  'plugin.invalid_plugin_configuration': 'Ungültige Plugin-Konfiguration.',
  'plugin.invalid_plugin_manifest': 'Ungültiges Plugin-Manifest.',
  'plugin.migration_failed': 'Migration „{migId}“ fehlgeschlagen: {message}',
  'plugin.migrations_have_completed':
    'Migrationen nicht abgeschlossen: {value}.',
  'plugin.needs_service_which_installation_does':
    '„{pluginKey}“ braucht den Dienst „{serviceName}“, den diese Installation nicht verbindet (SERVICE_PLUGINS).',
  'plugin.no_newer_version_available': 'Keine neuere Version verfügbar.',
  'plugin.package_signature_invalid': 'Die Paketsignatur ist ungültig.',
  'plugin.package_signature_invalid_refusing_install':
    'Die Paketsignatur ist ungültig; Installation verweigert.',
  'plugin.plugin_already_installed':
    'Das Plugin „{key}“ ist bereits installiert.',
  'plugin.plugin_does_hold_storage_plugin':
    'Das Plugin hat die Berechtigung storage.plugin nicht.',
  'plugin.plugin_enabled': 'Das Plugin ist nicht aktiviert.',
  'plugin.plugin_enabled_from_status':
    'Das Plugin „{key}“ kann aus dem Status {pluginStatus} nicht aktiviert werden.',
  'plugin.plugin_installed': 'Das Plugin ist nicht installiert.',
  'plugin.plugin_package_no_longer_present':
    'Das Plugin-Paket ist nicht mehr in der Registry.',
  'plugin.records_may_at_most_bytes':
    'Datensätze dürfen höchstens {PLUGINDATAMAXBYTES} Byte groß sein.',
  'plugin.service_bound_plugin_service_plugins':
    'Der Dienst „{serviceName}“ ist nicht mit diesem Plugin verbunden (SERVICE_PLUGINS).',
  'plugin.service_setup_failed':
    'Einrichtung des Dienstes fehlgeschlagen: {reason}',
  'plugin.turned_yet': '„{flag}“ kann noch nicht eingeschaltet werden.',
  'plugin.uninstall_dependent_plugins_first':
    'Deinstallieren Sie zuerst abhängige Plugins: {value}.',
  'plugin.uninstall_plugin_before_deleting':
    'Deinstallieren Sie das Plugin vor dem Löschen.',
  'plugin.unknown_capabilities_provided_dependency':
    'Unbekannte Berechtigungen (von keiner Abhängigkeit bereitgestellt): {undeclared}.',
  'plugin.use_retry_migrations_uninstall_first':
    'Wiederholen Sie die Migrationen oder deinstallieren Sie zuerst.',
  'runtime.migration_already_running':
    'Für {pluginKey} läuft bereits eine Migration.',
  'runtime.migration_failed':
    'Die Plugin-Migration ist fehlgeschlagen: {reason}',
  'validation.arrayMaxSize': '{property} hat zu viele Einträge',
  'validation.arrayMinSize': '{property} hat zu wenige Einträge',
  'validation.isArray': '{property} muss eine Liste sein',
  'validation.isBoolean': '{property} muss wahr oder falsch sein',
  'validation.isDateString': '{property} muss ein ISO-Datum sein',
  'validation.isEmail': '{property} muss eine E-Mail-Adresse sein',
  'validation.isEnum': '{property} hat einen nicht erlaubten Wert',
  'validation.isHexColor': '{property} muss eine Hex-Farbe sein',
  'validation.isIP': '{property} muss eine IP-Adresse sein',
  'validation.isISO8601': '{property} muss ein ISO-Datum sein',
  'validation.isIn': '{property} hat einen nicht erlaubten Wert',
  'validation.isInt': '{property} muss eine ganze Zahl sein',
  'validation.isLocale': '{property} muss ein Sprachcode sein',
  'validation.isNotEmpty': '{property} darf nicht leer sein',
  'validation.isNumber': '{property} muss eine Zahl sein',
  'validation.isObject': '{property} muss ein Objekt sein',
  'validation.isPhoneNumber': '{property} muss eine Telefonnummer sein',
  'validation.isPositive': '{property} muss positiv sein',
  'validation.isString': '{property} muss ein Text sein',
  'validation.isUUID': '{property} muss eine UUID sein',
  'validation.isUrl': '{property} muss eine URL sein',
  'validation.length': '{property} hat die falsche Länge',
  'validation.matches': '{property} hat ein ungültiges Format',
  'validation.max': '{property} ist zu groß',
  'validation.maxLength': '{property} ist zu lang',
  'validation.min': '{property} ist zu klein',
  'validation.minLength': '{property} ist zu kurz',
  'validation.nestedValidation': '{property} ist ungültig',
  'validation.whitelistValidation':
    'Die Eigenschaft {property} ist nicht erlaubt',
  // English until translated.
  'identity.service_not_member_admin':
    'Der Dienst „{service}“ darf keine Mitgliederkonten verwalten (MEMBER_ADMIN_CLIENTS).',
  'nearee.grant_days': 'Gib zwischen 1 und 3650 Tagen an.',
  'nearee.grant_until': 'Das Enddatum muss in den nächsten zehn Jahren liegen.',
  'nearee.subscription_paid':
    'Ein bezahltes Abo wird im App Store, bei Google Play oder in Stripe geändert.',
}
